import { render, staticRenderFns } from "./VTableIconDelete.vue?vue&type=template&id=67f295c1&"
import script from "./VTableIconDelete.vue?vue&type=script&lang=ts&"
export * from "./VTableIconDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports